import { ITEM_KINDS } from '../../constants/itemSlideOut.js';
import InsightDetailSlideOut from '../intelligence/InsightDetailSlideOut.jsx';
import ConflictCompareSlideOut from '../knowledge/sandbox/ConflictCompareSlideOut.jsx';
import TraitDetailSlideOut from '../intelligence/TraitDetailSlideOut.jsx';
import TruthFactSlideOut from '../knowledge/truth/TruthFactSlideOut.jsx';

/**
 * Which component opens each item kind in the profile slide-out. Each ticket
 * adds its own line: insight (CT-5716), claim_compare (CT-5718), truth
 * (CT-5719). A kind missing here — including the reserved `task` and
 * `history_event` — opens the unavailable state.
 *
 * Every component receives `{ itemId, entityType, entityId, entityTitle, onClose,
 * onOpenHistoryEvent, onChanged }`; `onOpenHistoryEvent` is undefined when the
 * profile has no History tab, `onChanged` is called after the item was changed.
 */
export const ITEM_SLIDEOUT_COMPONENTS = Object.freeze({
  [ITEM_KINDS.TRAIT]: TraitDetailSlideOut,
  [ITEM_KINDS.INSIGHT]: InsightDetailSlideOut,
  [ITEM_KINDS.CLAIM_COMPARE]: ConflictCompareSlideOut,
  [ITEM_KINDS.TRUTH]: TruthFactSlideOut,
});
